import { Box, Text, Flex } from "@chakra-ui/react";
import PointsChart from "../charts/PointsChart";
import { useUser } from "../../context/UserContext";

const BlurChartWrapper = ({ data, onMintModalOpen }) => {
	const { user, loading } = useUser();

	const isUserHasKey = !loading && user && user.mintedKey;

	const handleBlurClick = () => {
		onMintModalOpen();
	};

	return (
		<Flex
			position="relative"
			w="100%"
			h="auto"
			justifyContent="center"
			alignItems="center"
			direction="column"
		>
			{/* График */}
			<Box
				w="100%"
				maxW="700px"
				p={4}
				// bg="white"
				// borderRadius="md"
				// border="0.2px solid #FF684B"
				// boxShadow="md"
				zIndex={1} // График находится под слоем с размытием
			>
				<PointsChart data={data} />
			</Box>

			{/* Полупрозрачный слой с эффектом размытия */}
			<Box
				cursor={"pointer"}
				position="absolute"
				top={0}
				left={0}
				w="100%"
				h="100%"
				bg="rgba(255, 255, 255, 0.5)" // Полупрозрачный фон
				backdropFilter="blur(5px)" // Эффект размытия
				borderRadius="md"
				zIndex={2} // Полупрозрачный слой поверх графика
				onClick={handleBlurClick} // Обработка кликов
				display="flex"
				alignItems="center"
				justifyContent="center"
				pointerEvents="auto" // Включаем клики на слой
			>
				<Text
					fontSize="lg"
					color="gray.600"
					textAlign="center"
					fontWeight="bold"

				>
					Show marks chart
				</Text>
			</Box>
		</Flex>
	);
};

export default BlurChartWrapper;
